var gs1Validator = require('./gs1Validator');
module.exports = function isPackageLicencePlate(value) {
    if(!value)
        return false;
    if(value.substring(0,2) == "00" && value.length == 20)
		value = value.substring(2);
	if(value.length == 18)
		return gs1Validator(value);
	return false;
}
